/** @format */

export function getImagePosition(imagePos) {
  if (imagePos === 'left') return 'left';
  return 'right';
}
